export default __webpack_public_path__ + "static/media/logo_white.897a83e3.svg";